import { IonFab, IonFabButton, IonIcon, useIonToast } from '@ionic/react';
import { addCircleOutline, chatboxOutline, mailOutline, personOutline } from 'ionicons/icons';
import { useContext, useEffect, useState } from 'react';
import { Modal } from 'react-responsive-modal';

import ActionButton from '../../components/button/ActionButton';
import InputItem from '../../components/input/InputItem';
import { AuthContext } from '../../context/AuthContext';
import { DataProvider } from '../../library/DataProvider';
import { CommentPostAction } from '../../redux/actions/Comment';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';

import './AddComment.css';
import 'react-responsive-modal/styles.css';

interface Props {
    type: string,
    id: string,
    show: boolean,
    clickShow: any,
    clickHide: any,
    commentPostDone: any
}

const AddComment: React.FC<Props> = (props) => {
    const [toast, dismiss] = useIonToast();

    const authContext = useContext(AuthContext);

    const dispatch = useAppDispatch()

    let { form_loading, resp } = useAppSelector((state) => {
        if (props.type == 'campaign')
            return state.campaignCommentPost;
        else if (props.type == 'blog')
            return state.blogCommentPost;
        else if (props.type == 'product')
            return state.productCommentPost;

        return state.productCommentPost;
    })

    const [form, setForm] = useState({
        name: { value: "", validation: { required: true }, error: "" },
        mobile: { value: "", validation: { min: 11, max: 11 }, error: "" },
        comment: { value: "", validation: { required: true }, error: "" }
    });

    const [formProvider] = useState(() => new DataProvider(form, setForm));

    const formSubmitHandler = (e: any) => {
        e.preventDefault();

        let formValidation = formProvider.validation(form);

        if (formValidation) {
            dispatch(CommentPostAction(props.type, props.id, authContext.auth ? "" : form.name!.value, authContext.auth ? "" : form.mobile!.value, form.comment.value))
        }
    }

    useEffect(() => {
        if (authContext.auth) {
            const f = { ...form };
            f.name.value = "user";
            setForm(f);
        }
    }, [authContext])

    useEffect(() => {
        const formDone = () => {
            if (resp != null && !form_loading) {
                if (resp.result) {
                    toast({ message: resp.message, duration: 2000, color: "primary" })

                    formProvider.reset();

                    props.commentPostDone()
                } else {
                    toast({ message: resp.message, duration: 2000, color: "danger" })
                }
            }
        }

        formDone();
    }, [form_loading])

    const inputs = <>
        <InputItem name="name" type="text" label="نام کامل" icon={personOutline} maxlength={50} provider={formProvider} />

        <InputItem name="mobile" type="text" label="ایمیل یا تلفن همراه" icon={mailOutline} maxlength={100} ltr spaced provider={formProvider} />
    </>

    return <>
        <IonFab vertical="bottom" horizontal="end">
            <IonFabButton onClick={props.clickShow}><IonIcon icon={addCircleOutline} /></IonFabButton>
        </IonFab>

        <Modal open={props.show} onClose={props.clickHide} center showCloseIcon={false}>
            <form onSubmit={formSubmitHandler}>
                <AuthContext.Consumer>
                    {
                        (context) => context.auth ? <div className="ion-hide">{inputs}</div> : <>{inputs}</>
                    }
                </AuthContext.Consumer>

                <InputItem name="comment" type="textarea" label="نظر شما" icon={chatboxOutline} maxlength={1000} rows={5} provider={formProvider} />

                <ActionButton text="ارسال نظر" loading={form_loading} />
            </form>
        </Modal>
    </>
};

export default AddComment